import VerificationCode from './verification-code';
import { VerificationCodeProps } from './interface';

export { VerificationCodeProps };

export default VerificationCode;
